import React from 'react';
import { Form, ButtonToolbar, Button } from 'react-bootstrap';

import BorderButton from '../../../../components/BorderButton';
import Link from '../../../../components/Link/Link';
import PageSubHeading from '../../../../components/PageSubHeading';
import FormField from '../../../../components/FormField';

import {
  FORGOT_PASSWORD,
  EMAIL,
  REQUEST_RESET_LINK,
  LOGIN,
  FORGOT_PASSWORD_CLASS,
  REQUESTING,
} from '../../../../common/i18n';
import { Props, State } from './flowTypes';
import './style.scss';

class ForgotPassword extends React.PureComponent<Props, State> {
  render() {
    const {
      resetpasswordlinksent,
    } = this.props;

    return resetpasswordlinksent ?
      this.renderConfirmation() : this.renderForgotPasswordForm();
  }

  ///////////////////////////////////////
  ///////////RENDER METHODS/////////////
  //////////////////////////////////////
  renderConfirmation = () => {
    const {
      user: {
        email
      },
      history,
      resetPasswordResetRequest,
    } = this.props;
    return (
      <div className='forgot-password-form'>
        <PageSubHeading
          className={'forgot-password-form-header'}
          headerText={FORGOT_PASSWORD}
        />
        <div className="icon-Email-sent"></div>
        <div className="forgot-password-form-confirmation">
          A link to help you reset your password has been sent to {email}
        </div>
        <BorderButton
          className="back-to-login"
          style={{'width': '111px'}}
          onClick={() => {
            history.push('/login');
            resetPasswordResetRequest();
          }}
        >
          Back to Login
        </BorderButton>
      </div>
    );
  }

  renderForgotPasswordForm = () => {
    const {
      history,
      user,
      isEmailValid,
      onLoginFieldsInput,
      validateEmail,
      onSubmit,
      error,
      loading,
    } = this.props;
    return (
      <Form
        className={'forgot-password-form'}
        onSubmit={() => null}
      >
        <PageSubHeading
          className={'forgot-password-form-header'}
          headerText={FORGOT_PASSWORD}
        />
        <FormField
          formClassName={FORGOT_PASSWORD_CLASS}
          label={EMAIL}
          controlId={FORGOT_PASSWORD_CLASS}
          fieldClassName={FORGOT_PASSWORD_CLASS}
          type='email'
          name='email'
          value={user.email}
          placeholder='sadie.boone@gmail.com'
          required={true}
          onFieldsInput={(e) => {
            onLoginFieldsInput(e);
            validateEmail(e);
          }}
          onBlur={validateEmail}
          error={error}
          disabled={false}
        />
        <ButtonToolbar className="forgot-password-form-btn-container">
          <Button
            style={{height: '44px', width: '100%'}}
            variant="primary"
            type="submit"
            className="update-password"
            disabled={!isEmailValid || !user.email}
            onClick={(event) => {
              event.preventDefault();
              if (loading) {
                return;
              }
              onSubmit(event);
            }}
          >
            {loading ? REQUESTING : REQUEST_RESET_LINK}
          </Button>
        </ButtonToolbar>
        <Form.Label>Remember your password?</Form.Label>
        <Link
          variant='secondary-link'
          onClick={() => history.push('/login')}
        >
          {LOGIN}
        </Link>
      </Form>
    );
  }
}

export default ForgotPassword;
